import { formatCurrency } from "../helpers/index.js";
import { getItemTypeTitle } from "./getItemTypeTitle.js";

export const generateContainerTypeDeliveryChargeRulesText = ({
  value,
  containerType,
}: {
  value: number;
  containerType: string;
}) => {
  return `Spend ${formatCurrency(value)} on ${getItemTypeTitle(
    containerType,
    2,
  )} - no delivery charge`;
};
